<template>
    <v-dialog
        v-model="$store.state.groupFSC.add"
        max-width="1000px"
        transition="dialog-transition"
    >
        <v-card>
            <v-toolbar color="primary" dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Add Group
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.state.groupFSC.add = false; "><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row justify="center">
                    <v-col cols="8">
                        <v-text-field label="Group Name" v-model="GroupName" required></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="end">
                    <v-btn color="secondary" class="mr-5 mb-5" @click="saveGroup">Save</v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
    export default {
        props:['parms'],
        data: function() {
            return {
                GroupName: this.GroupName
            }
        },
        methods:{
            saveGroup: function() {
                var str = this.$store;
                var parms = {
                    GroupName: this.GroupName
                }
                if(this.GroupName == null || this.GroupName == ""){
                    this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Enter group name'
                        });
                }else{
                    axios
                    .post('invoice-group-customer', parms,{
                        headers:{
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(respose => {
                        console.log(respose.data);
                        str.dispatch('setSnackbar', {
                                color: 'success',
                                text:
                                    'Group saved'
                            });
                        this.$emit('close');
                        
                    })
                    .catch(err => {
                        console.log(err);
                    })
                }
            }
        }
    }
</script>